import { render, staticRenderFns } from "./CustomerContractReadjustmentForm.vue?vue&type=template&id=5bfd8809"
import script from "./CustomerContractReadjustmentForm.vue?vue&type=script&lang=js"
export * from "./CustomerContractReadjustmentForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerContractReadjustmentForm.vue?vue&type=style&index=0&id=5bfd8809&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports